export const reducers = (state = [], action) => {
  switch (action.type) {
    case 'show_modal':
      return { ...state, modal: action.payload };
    case 'hide_modal':
      return { ...state, modal: null};
    case 'make_full':
      return { ...state, fullScreen: action.payload}
    default:
      return state;
  }
};
